export function toWebSaleSyncPayload(sale) {
  return {
    amountPaid: Number(sale?.amountPaid || 0),
    balanceDue: Number(sale?.balanceDue || 0),
    cashier: sale?.cashier,
    createdAtIso: sale?.createdAtIso || sale?.createdAt || undefined,
    debtId: sale?.debtId || null,
    id: sale?.id,
    ...(sale?.inventoryExecutionMode ? { inventoryExecutionMode: sale.inventoryExecutionMode } : {}),
    items: (sale?.items || []).map((item) => ({
      cartId: item.cartId,
      name: item.name,
      productId: item.productId,
      quantity: Number(item.quantity || 1),
      stock: item.stock === null || item.stock === undefined ? null : Number(item.stock),
      unitPrice: Number(item.unitPrice || 0),
    })),
    location: sale?.location,
    ...(Array.isArray(sale?.offlineInventoryGrants) && sale.offlineInventoryGrants.length
      ? { offlineInventoryGrants: sale.offlineInventoryGrants.map((grant) => ({
        grantId: grant.grantId,
        productId: grant.productId,
        version: Number(grant.version || 0),
      })) }
      : {}),
    paymentStatus: sale?.paymentStatus,
    total: Number(sale?.total || 0),
  };
}

export function sanitizeWebSyncPayload(operationType, payload) {
  return operationType === "SALE_RECORDED" ? toWebSaleSyncPayload(payload) : payload;
}
